import { useContext } from 'react';
import { BotContext } from '../context/BotContext';

const useBot = () => useContext(BotContext);

export default useBot;
